// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1u-e";
export var animationRelative = "_1u-d";
export var backdropBlur = "_1u-0";
export var detailLabelCell = "_1u-q";
export var detailTable = "_1u-p";
export var detailValueCell = "_1u-r";
export var documentTypeIcon = "_1u-y";
export var documentTypeOption = "_1u-x";
export var dropdownMatchDatePicker = "_1u-3";
export var evidenceCardContent = "_1u-w";
export var gorgiasTicketCard = "_1u-s";
export var iconTertiary = "_1u-z";
export var integrationCard = "_1u-1";
export var integrationLogoBox = "_1u-2";
export var mainColumnSticky = "_1u-v";
export var maxWidthContainer = "_1u-t";
export var modalContentBody = "_1u-a";
export var modalHeaderImage = "_1u-5";
export var modalImageLabel = "_1u-7";
export var modalImageOverlay = "_1u-6";
export var modalImageSubtitle = "_1u-9";
export var modalImageTitle = "_1u-8";
export var modalImageWrapper = "_1u-4";
export var modalStickyFooter = "_1u-b";
export var sidebarColumn = "_1u-u";
export var timelineLine = "_1u-m";
export var timelineLineBlack = "_1u-o _1u-m";
export var timelineLineGray = "_1u-n _1u-m";
export var timelineLineHeight = "_1u-l";
export var tlDotActivate = "_1u-i";
export var tlDotActivateAnim = "_1u-h";
export var tlDotHide = "_1u-g";
export var tlDotHideAnim = "_1u-f";
export var tlLineActivate = "_1u-k";
export var tlLineActivateAnim = "_1u-j";
export var uploadedFileRow = "_1u-c";